import { StoryCharacter } from './character.model';

export const DEFAULT_SENSEI_CHARACTER = {
  file: 'assets/images/onboarding/hovering_sensei.riv',
  artboard: 'Floating Sensei',
  stateMachine: 'State Machine 1',
  isBackground: false,
  customStyles: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  mobileCustomStyles: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  isCentered: false,
  widthPixel: 500,
  heightPixel: 500,
} as const satisfies StoryCharacter;
